import React, { useEffect, useState } from 'react';
import { Menu, X, Phone, Shield } from 'lucide-react';
import { Button } from './ui/Button';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Про компанію',
    href: '#about'
  }, {
    name: 'Послуги',
    href: '#services'
  }, {
    name: 'Переваги',
    href: '#why-us'
  }, {
    name: 'FAQ',
    href: '#faq'
  }, {
    name: 'Контакти',
    href: '#contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white ${isScrolled ? 'border-b border-neutral-100 py-4' : 'py-6'}`} data-id="element-118">
      <div className="container mx-auto px-6 md:px-8 max-w-7xl" data-id="element-119">
        <div className="flex items-center justify-between" data-id="element-120">
          {/* Logo */}
          <a href="#" className="flex items-center gap-3 group" data-id="element-121">
            <div className="p-1.5 border border-black rounded-none" data-id="element-122">
              <Shield className="h-5 w-5 text-black" data-id="element-123" />
            </div>
            <div className="flex flex-col" data-id="element-124">
              <span className="font-bold text-lg leading-none text-black tracking-tight" data-id="element-125">
                Військовий Адвокат
              </span>
            </div>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-126">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-neutral-500 hover:text-black transition-colors" data-id="element-127">
                {link.name}
              </a>)}
          </nav>

          {/* CTA & Mobile Toggle */}
          <div className="flex items-center gap-6" data-id="element-128">
            <a href="tel:+380633540689" className="hidden md:flex items-center gap-2 font-medium text-black hover:text-neutral-600 transition-colors group" data-id="element-129">
              <Phone className="h-4 w-4 group-hover:animate-pulse" data-id="element-130" />
              <span className="text-sm" data-id="element-131">+380 63 354 06 89</span>
            </a>
            <Button variant="primary" size="sm" className="hidden md:inline-flex" onClick={() => document.getElementById('contact')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-132">
              Консультація
            </Button>

            <button className="md:hidden p-2 text-black" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-133">
              {isMobileMenuOpen ? <X className="h-6 w-6" data-id="element-134" /> : <Menu className="h-6 w-6" data-id="element-135" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="absolute top-full left-0 right-0 bg-white border-b border-neutral-100 p-6 md:hidden flex flex-col gap-4 animate-in slide-in-from-top-2" data-id="element-136">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-black font-medium py-3 border-b border-neutral-100 last:border-0" onClick={() => setIsMobileMenuOpen(false)} data-id="element-137">
              {link.name}
            </a>)}
          <div className="pt-4 flex flex-col gap-3" data-id="element-138">
            <a href="tel:+380633540689" className="flex items-center justify-center gap-2 font-medium text-black py-2" data-id="element-139">
              <Phone className="h-4 w-4" data-id="element-140" />
              +380 63 354 06 89
            </a>
            <Button className="w-full" onClick={() => {
          setIsMobileMenuOpen(false);
          document.getElementById('contact')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} data-id="element-141">
              Замовити консультацію
            </Button>
          </div>
        </div>}
    </header>;
}